var isLoggedIn;
$.cookie = function(e, t, a) {
    if (arguments.length > 1 && (!/Object/.test(Object.prototype.toString.call(t)) || null == t)) {
        if (a = $.extend({}, a), null == t && (a.expires = -1), "number" == typeof a.expires) {
            var i = a.expires,
                o = a.expires = new Date;
            o.setDate(o.getDate() + i)
        }
        return t = String(t), document.cookie = [encodeURIComponent(e), "=", a.raw ? t : encodeURIComponent(t), a.expires ? "; expires=" + a.expires.toUTCString() : "", a.path ? "; path=" + a.path : "", a.domain ? "; domain=" + a.domain : "", a.secure ? "; secure" : ""].join("")
    }
    for (var s, n = (a = t || {}).raw ? function(e) {
            return e
        } : decodeURIComponent, l = document.cookie.split("; "), c = 0; s = l[c] && l[c].split("="); c++)
        if (n(s[0]) === e) return n(s[1] || "");
    return null
}, "undefined" == typeof Shopify && (Shopify = {}), Shopify.formatMoney || (Shopify.formatMoney = function(e, t) {
    var a = "",
        i = /\{\{\s*(\w+)\s*\}\}/,
        o = t || this.money_format;

    function s(e, t) {
        return void 0 === e ? t : e
    }

    function n(e, t, a, i) {
        if (t = s(t, 2), a = s(a, ","), i = s(i, "."), isNaN(e) || null == e) return 0;
        var o = (e = (e / 100).toFixed(t)).split(".");
        return o[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + a) + (o[1] ? i + o[1] : "")
    }
    switch ("string" == typeof e && (e = e.replace(".", "")), o.match(i)[1]) {
        case "amount":
            a = n(e, 2);
            break;
        case "amount_no_decimals":
            a = n(e, 0);
            break;
        case "amount_with_comma_separator":
            a = n(e, 2, ".", ",");
            break;
        case "amount_no_decimals_with_comma_separator":
            a = n(e, 0, ".", ",")
    }
    return o.replace(i, a)
}), window.novtheme = window.novtheme || {}, isLoggedIn = !1;
var current_width = $(window).width(),
    min_width = 768,
    responsive_mobile = current_width < min_width,
    wishListsArr = localStorage.getItem("wishListsArr") ? JSON.parse(localStorage.getItem("wishListsArr")) : [];
localStorage.setItem("wishListsArr", JSON.stringify(wishListsArr)), wishListsArr.length && (wishListsArr = JSON.parse(localStorage.getItem("wishListsArr"))), novtheme.init = function() {
    novtheme.eventBlockCart(), novtheme.VerticalThumbnailProductDetail(), novtheme.ThumbnailProductDetail(), novtheme.RelatedProduct(), novtheme.load_canvas_menu(), novtheme.NovTogglePage(), novtheme.Countdown(), novtheme.goToTop(), novtheme.goToTopMobile(), novtheme.MenuSidebar(), novtheme.HideShowPassword(), novtheme.NovSearchToggle(), novtheme.NovSearchOverlay(), novtheme.tooltip(), novtheme.Nov_iframe_video(), novtheme.MegaMenuSlider(), novtheme.LoadmoreByButton(), novtheme.Mainmenu(), novtheme.CollectionPage(), novtheme.CollectionPageLoadmore(), novtheme.NovAccordion(), novtheme.RunParallax(), novtheme.LookBook(), novtheme.Language(), novtheme.CartExtent(), novtheme.AddActive(), novtheme.ProductStick(), novtheme.Header_mobile(), novtheme.Copy(), novtheme.PageSizeGuild(), novtheme.MobileSlider(), novtheme.StickyHeader(), novtheme.ProductSingleSlider(), novtheme.NovSnow(), novtheme.SlideShowParallax(), novtheme.Vertical(), novtheme.BtnSlider(), novtheme.NavDropdownMobile(), novtheme.NumberAnimate(), novtheme.FakeOrder(), novtheme.CookieGDPR()
}, novtheme.tooltip = function() {
    $("body").tooltip({
        selector: "[data-toggle='tooltip']",
        container: "body"
    })
}, novtheme.swapChildren = function(e, t) {
    var a = t.children().detach();
    t.empty().append(e.children().detach()), e.append(a)
}, novtheme.toggleMobileStyles = function() {
    responsive_mobile ? $("*[id^='_desktop_']").each((function(e, t) {
        var a = $("#" + t.id.replace("_desktop_", "_mobile_"));
        a && novtheme.swapChildren($(t), a)
    })) : $("*[id^='_mobile_']").each((function(e, t) {
        var a = $("#" + t.id.replace("_mobile_", "_desktop_"));
        a && novtheme.swapChildren($(t), a)
    }))
}, novtheme.toggleSticky = function(e) {
    1 == e ? $("*[class^='contentsticky_']").each((function(e, t) {
        var a = $("." + t.classList[0].replace("contentsticky_", "contentstickynew_"));
        a.length && novtheme.swapChildren($(t), a)
    })) : $("*[class^='contentstickynew_']").each((function(e, t) {
        var a = $("." + t.classList[0].replace("contentstickynew_", "contentsticky_"));
        a.length && novtheme.swapChildren($(t), a)
    }))
}, novtheme.StickyHeader = function() {
    if ($(window).width() > 767 && $(".site-header").hasClass("sticky-header")) {
        var e = $(".site-header").height(),
            t = $(".header-center").height(),
            a = !0,
            i = 0;
        $(window).scroll((function() {
            var o = $(window).scrollTop();
            o < i && o > e ? 1 == a && ($("#header-sticky").addClass("sticky-header-active"), $(".header-center").css("height", t), novtheme.toggleSticky(!0), a = !1) : 0 == a && ($("#header-sticky").removeClass("sticky-header-active"), novtheme.toggleSticky(!1), $(".header-center").css("height", "auto"), a = !0), i = o
        }))
    }
    if ($(window).width() < 768 && $(".header-mobile").hasClass("sticky-header-mobile")) {
        var o = $(".site-header").height(),
            s = !0,
            n = 0;
        $(window).scroll((function() {
            if ($(".section-promotion-bar").length > 0) var e = $(".section-promotion-bar").height();
            var t = $(window).scrollTop();
            t < n && t > o ? 1 == s && ($(".header-mobile").addClass("sticky-header-active"), $("#mobile_menu").css("padding-top", "60px"), s = !1) : 0 == s && ($(".header-mobile").removeClass("sticky-header-active"), $(".section-promotion-bar .distance").hasClass("act") ? $("#mobile_menu").css("padding-top", o + e) : $("#mobile_menu").css("padding-top", o), s = !0), n = t, $(window).scrollTop() > o ? $(".header-mobile").addClass("down") : $(".header-mobile").removeClass("down")
        }))
    }
}, $(window).on("resize", (function() {
    var e = current_width,
        t = min_width,
        a = $(window).width();
    responsive_mobile = e >= t, current_width = a, (e >= t && a < t || e < t && a >= t) && (novtheme.toggleMobileStyles(), novtheme.load_canvas_menu(), novtheme.NovTogglePage())
})), novtheme.load_canvas_menu = function() {
    var e = $(".site-nav-mobile");
    if (current_width < 1200) {
        if ($("#canvas-main-menu").length < 1 && e.length > 0) {
            var t = e.parent().clone();
            t.attr("id", "canvas-main-menu"), $(t).find(".menu").removeAttr("id"), $(".canvas-menu").append(t), t.mmenu({
                offCanvas: !1,
                navbar: {
                    title: !1
                }
            })
        }
        $(".mm-next").click((function() {
            $(".navmenu-product .grid--view-items").slick("refresh")
        }))
    }
}, novtheme.Header_mobile = function() {
    $("#show-megamenu").click((function() {
        $(this).hasClass("act") ? ($(this).removeClass("act"), $("body").css("overflow", "auto"), $(".sidebar-overlay, #mobile_menu").removeClass("act"), $(".sidebar-overlay").css("z-index", "99")) : ($(this).addClass("act"), $("body").css("overflow", "hidden"), $(".sidebar-overlay, #mobile_menu").addClass("act"), $(".sidebar-overlay").css("z-index", "100")), $(".mobile-btn_search, #mobile_search").removeClass("act")
    })), $(".mobile-btn_search").click((function() {
        $(this).hasClass("act") ? ($(this).removeClass("act"), $("#mobile_search").removeClass("act")) : ($(this).addClass("act"), $("#mobile_search").addClass("act")), $("body").css("overflow", "auto"), $(".sidebar-overlay, #show-megamenu, #mobile_menu").removeClass("act")
    }));
    var e = $(".site-header").outerHeight(),
        t = 0;
    if ($(".section-promotion-bar").length > 0) t = $(".section-promotion-bar").outerHeight();
    $("#mobile_menu").css("padding-top", e + t), $(".promotion-close").click((function() {
        $("#mobile_menu").css("padding-top", e)
    }))
}, novtheme.Copy = function() {
    $(".copy-btn").click((function() {
        const e = $(this),
            t = e.data("copy"),
            a = e.data("copied");
        e.siblings("input")[0].select(), document.execCommand("copy"), window.getSelection().removeAllRanges(), e.text(a), setTimeout((() => e.text(t)), 2500)
    }))
}, novtheme.VerticalThumbnailProductDetail = function() {
    $(window).width() > 991 && $(".template-product").length > 0 && ($(window).on("mousewheel DOMMouseScroll wheel", (function(e) {
        var t = $(".product-template__scroll .proFeaturedImage");
        t.find(".item.act").each((function() {
            var a = $(this),
                i = a.data("position"),
                o = a.height() / 2,
                s = $(window).scrollTop(),
                n = e.originalEvent.deltaY,
                l = a.offset().top;
            if (n > 0) {
                if (i < t.find(".item").length) var c = i + 1;
                else c = i;
                s > l + o && (a.removeClass("act"), t.find('.item[data-position="' + c + '"]').addClass("act"), $('.thumbItem[data-position="' + i + '"]').removeClass("active"), $('.thumbItem[data-position="' + c + '"]').addClass("active"))
            } else {
                if (i > 1) var d = i - 1;
                else d = i;
                s < l - o && (a.removeClass("act"), t.find('.item[data-position="' + d + '"]').addClass("act"), $('.thumbItem[data-position="' + i + '"]').removeClass("active"), $('.thumbItem[data-position="' + d + '"]').addClass("active"))
            }
            $(".product-template__scroll .thumb_vertical_slick").slick("slickGoTo", i)
        }))
    })), $(".product-template__scroll .thumbItem").click((function() {
        var e = $(this).data("position");
        $(".product-template__scroll .thumbItem").removeClass("active"), $(this).addClass("active"), $(".proFeaturedImage .item").removeClass("act"), $('.proFeaturedImage .item[data-position="' + e + '"]').addClass("act");
        var t = $(".proFeaturedImage .item.act").offset().top;
        $("body,html").animate({
            scrollTop: t - 60
        }, "normal")
    }))), $(window).width() < 992 && ($(".product-template__scroll .proFeaturedImage, .product-template__imggrid .proFeaturedImage").slick({
        slide: ".item",
        infinite: !1,
        arrows: !1,
        dots: !0,
        slidesToShow: 1,
        slidesToScroll: 1
    }).on("afterChange", (function(e, t) {
        $("iframe").each((function() {
            $(this)[0].contentWindow.postMessage('{"event":"command","func":"stopVideo","args":""}', "*")
        })), $(".product-template__scroll .proFeaturedImage").find(".slick-slide:not(.slick-active) video").trigger("pause")
    })), $(".product-template__scroll .proFeaturedImage").on("afterChange", (function(e, t, a) {
        $("#productThumbs .thumb_slick").slick("slickGoTo", a), $("#productThumbs .thumb_slick").find(".slick-slide").removeClass("active"), $("#productThumbs .thumb_slick").find('.slick-slide[data-slick-index="' + a + '"]').addClass("active")
    })), $(".product-template__scroll .thumb_slick").on("click", ".thumbItem", (function(e) {
        e.preventDefault(), $(".thumb_slick").find(".slick-slide").removeClass("active"), $(this).addClass("active");
        var t = $(this).data("slick-index");
        $(".product-template__scroll .proFeaturedImage").slick("slickGoTo", t)
    })), $("variant-radios label").click((function() {
        setTimeout((function() {
            var e = $(".product-template__scroll .proFeaturedImage, .product-template__imggrid .proFeaturedImage").find(".item.act").attr("data-slick-index");
            $(".product-template__scroll .proFeaturedImage, .product-template__imggrid .proFeaturedImage").slick("slickGoTo", e)
        }), 300)
    })))
}, novtheme.ThumbnailProductDetail = function() {
    var e = $(".FeaturedImage_slick"),
        t = $("#productThumbs .thumb_slick");
    if ($("html").hasClass("lang-rtl")) var a = !0;
    else a = !1;
    var i = e.data("dots"),
        o = e.data("nav"),
        s = e.data("draggable"),
        n = (e.data("fade"), e.data("items")),
        l = e.data("items_lg"),
        c = e.data("items_md"),
        d = e.data("items_sm"),
        r = e.data("items_xs");
    if (t.find(".item").length < 20) var h = !0;
    else h = !1;
    e.slick({
        slide: ".item",
        nextArrow: '<div class="arrow-next"><i class="zmdi zmdi-chevron-right"></i></div>',
        prevArrow: '<div class="arrow-prev"><i class="zmdi zmdi-chevron-left"></i></div>',
        slidesToShow: n,
        slidesToScroll: n,
        dots: i,
        arrows: o,
        fade: !1,
        adaptiveHeight: !0,
        infinite: !1,
        useTransform: !0,
        speed: 500,
        cssEase: "cubic-bezier(0.77, 0, 0.18, 1)",
        rtl: a,
        draggable: s,
        responsive: [{
            breakpoint: 1200,
            settings: {
                slidesToShow: l,
                slidesToScroll: l,
                vertical: u,
                verticalSwiping: u
            }
        }, {
            breakpoint: 992,
            settings: {
                slidesToShow: c,
                slidesToScroll: c
            }
        }, {
            breakpoint: 768,
            settings: {
                slidesToShow: d,
                slidesToScroll: d,
                dots: !1
            }
        }, {
            breakpoint: 576,
            settings: {
                slidesToShow: r,
                slidesToScroll: r,
                dots: h
            }
        }]
    });
    t.data("autoplay"), t.data("autoplaytimeout");
    var m = t.data("loop"),
        v = (i = t.data("dots"), o = t.data("nav"), t.data("loop"), t.data("fade"), t.data("vertical")),
        u = t.data("vertical_lg"),
        p = t.data("vertical_md"),
        f = t.data("vertical_sm");
    n = t.data("items"), l = t.data("items_lg"), c = t.data("items_md"), d = t.data("items_sm"), r = t.data("items_xs");
    1 == v && (a = !1), t.on("init", (function(e, t) {
        $(this).find(".slick-slide.slick-current").addClass("active")
    })).slick({
        nextArrow: '<div class="arrow-next"><i class="zmdi zmdi-chevron-right"></i></div>',
        prevArrow: '<div class="arrow-prev"><i class="zmdi zmdi-chevron-left"></i></div>',
        slide: ".item",
        infinite: m,
        slidesToShow: n,
        slidesToScroll: n,
        dots: i,
        arrows: o,
        rtl: a,
        vertical: v,
        verticalSwiping: v,
        focusOnSelect: !1,
        responsive: [{
            breakpoint: 1200,
            settings: {
                slidesToShow: l,
                slidesToScroll: l,
                vertical: u,
                verticalSwiping: u
            }
        }, {
            breakpoint: 992,
            settings: {
                slidesToShow: c,
                slidesToScroll: c,
                vertical: p,
                verticalSwiping: p
            }
        }, {
            breakpoint: 768,
            settings: {
                slidesToShow: d,
                slidesToScroll: d,
                vertical: f,
                verticalSwiping: f
            }
        }, {
            breakpoint: 576,
            settings: {
                slidesToShow: r,
                slidesToScroll: r,
                vertical: !1,
                verticalSwiping: !1
            }
        }]
    }), e.on("afterChange", (function(a, i, o) {
        t.slick("slickGoTo", o), t.find(".slick-slide.active").removeClass("active"), t.find('.slick-slide[data-slick-index="' + o + '"]').addClass("active"), e.find(".slick-slide:not(.slick-active) iframe").each((function() {
            $(this)[0].contentWindow.postMessage('{"event":"command","func":"stopVideo","args":""}', "*")
        })), e.find(".slick-slide:not(.slick-active) video").trigger("pause"), $(".thumbgrid .thumbItem").removeClass("active"), $('.thumbgrid .thumbItem[data-position="' + o + '"]').addClass("active")
    })), t.on("click", ".slick-slide", (function(t) {
        t.preventDefault();
        var a = $(this).data("slick-index");
        e.slick("slickGoTo", a)
    })), $(".thumbgrid .thumbItem").on("click", (function(t) {
        t.preventDefault();
        var a = $(this).data("position");
        e.slick("slickGoTo", a)
    })), $("variant-radios label").click((function() {
        setTimeout((function() {
            var t = e.find(".item.act").attr("data-slick-index");
            e.slick("slickGoTo", t)
        }), 300)
    })), $(window).width() < 768 && $(".thumbgrid .thumblist").slick({
        infinite: !1,
        arrows: !1,
        dots: !1,
        slidesToShow: 4,
        slidesToScroll: 4
    })
}, novtheme.RelatedProduct = function() {
    $("html").hasClass("lang-rtl") ? rtl = !0 : rtl = !1;
    var e = $(".slick-relatedproduct"),
        t = $(e).data("nav"),
        a = $(e).data("dots"),
        i = $(e).data("loop"),
        o = $(e).data("items"),
        s = $(e).data("lg"),
        n = $(e).data("md"),
        l = $(e).data("sm"),
        c = $(e).data("xs");
    $(e).slick({
        nextArrow: '<div class="arrow-next"><i class="zmdi zmdi-chevron-right"></i></div>',
        prevArrow: '<div class="arrow-prev"><i class="zmdi zmdi-chevron-left"></i></i></div>',
        infinite: i,
        slidesToShow: o,
        slidesToScroll: o,
        rtl: rtl,
        dots: a,
        arrows: t,
        responsive: [{
            breakpoint: 1200,
            settings: {
                slidesToShow: s,
                slidesToScroll: s
            }
        }, {
            breakpoint: 992,
            settings: {
                slidesToShow: n,
                slidesToScroll: n
            }
        }, {
            breakpoint: 768,
            settings: {
                slidesToShow: l,
                slidesToScroll: l,
                arrows: !1,
                dot: !1
            }
        }, {
            breakpoint: 576,
            settings: {
                slidesToShow: c,
                slidesToScroll: c,
                arrows: !1,
                dot: !1
            }
        }]
    })
}, novtheme.Countdown = function() {
    function e(t, a, i) {
        var o = t.data("countdown"),
            s = (a = a || !1, i = i || !1, new Date(o).getTime()),
            n = "",
            l = new Date;
        n = s - l.getTime() < 0 && 1 == i ? new Date(l.getTime() + 1e3 * (86400 - 60 * l.getHours() * 60 - 60 * l.getMinutes() - l.getSeconds())) : o;
        var c = (a ? '<div class="item-time"><span class="data-number">%D</span><span class="name-time">' + theme.strings.days + "</span></div>" : "") + '<div class="item-time"><span class="data-number">%H</span><span class="name-time">' + theme.strings.hours + '</span></div><div class="item-time"><span class="data-number">%M</span><span class="name-time">' + theme.strings.minutes + '</span></div><div class="item-time"><span class="data-number">%S</span><span class="name-time">' + theme.strings.seconds + "</span></div>";
        t.countdown(n, (function(e) {
            t.html(e.strftime(c)), t.css("opacity", "1")
        })).on("finish.countdown", (function() {
            i && e(t, a, i)
        }))
    }
    $("[data-countdown]").each((function() {
        var t = $(this).data("show-days") || !1,
            a = $(this).data("restart") || !1;
        e($(this), t, a)
    }))
}, novtheme.eventBlockCart = function(e) {
    $(".cart_canvas .header-cart").click((function() {
        $(".sidebar-overlay").addClass("act"), $("#desktop_cart").addClass("active"), $("[nov-item-act], [nov-btn-act]").removeClass("act"), $(window).width() < 768 && ($("body").addClass("open-canvans-cart"), $("#show-megamenu, #mobile_menu").removeClass("act"))
    })), $(".close_cart").click((function() {
        $(".sidebar-overlay").removeClass("act"), $("#desktop_cart").removeClass("active"), $(".cart_extend").removeClass("act"), $(".extend--label__item").removeClass("act"), $(".cart_extend--label").removeClass("act"), $("[nov-item-act], [nov-btn-act]").removeClass("act"), $(window).width() < 768 && $("body").removeClass("open-canvans-cart")
    }))
}, novtheme.NovTogglePage = function() {
    $('.nov-toggle-page[data-target="#mobile-pageaccount"]').on("click", (function(e) {
        var t = $(this).data("target");
        $(t).hasClass("active") ? ($(t).removeClass("active"), $(".sidebar-overlay").removeClass("act").css("z-index", "99")) : ($(t).addClass("active"), $(".sidebar-overlay").addClass("act").css("z-index", "999")), e.preventDefault()
    })), $(".mobile-boxpage .close-box").on("click", (function(e) {
        $(this).parents(".mobile-boxpage").removeClass("active"), $(".sidebar-overlay").removeClass("act"), e.preventDefault()
    }))
}, novtheme.HideShowPassword = function() {
    $(".hide_show_password").show(), $(".hide_show_password span").addClass("show"), $(".hide_show_password span").click((function() {
        $(this).hasClass("show") ? ($(this).html('<i class="zmdi zmdi-eye"></i>'), $('input[name="customer[password]"]').attr("type", "text"), $(this).removeClass("show")) : ($(this).html('<i class="zmdi zmdi-eye-off"></i>'), $('input[name="customer[password]"]').attr("type", "password"), $(this).addClass("show"))
    })), $('form button[type="submit"]').on("click", (function() {
        $(".hide_show_password span").text("Show").addClass("show"), $(".hide_show_password").parent().find('input[name="customer[password]"]').attr("type", "password")
    })), $(".login_switch").on("click", (function() {
        $(this).hasClass("login-btn") ? ($(".login_switch_register--toggle").css("transform", "translate(0)"), $("#p_login").slideDown(), $("#p_register").slideUp()) : ($("html").hasClass("lang-rtl") ? $(".login_switch_register--toggle").css("transform", "translate(-100%)") : $(".login_switch_register--toggle").css("transform", "translate(100%)"), $("#p_login").slideUp(), $("#p_register").slideDown())
    }))
}, novtheme.NovSearchToggle = function() {
    $(".search-button").on("click", (function(e) {
        $(this).parent(".site-header__search").hasClass("search-active") ? $(this).removeClass("active").parent(".site-header__search").removeClass("search-active") : $(this).addClass("active").parent(".site-header__search").addClass("search-active"), e.stopPropagation()
    })), $(document).on("click", (function(e) {
        0 == $(e.target).is(".site-header__search input") && ($(".site-header__search").removeClass("search-active"), $(".search-button").removeClass("active"))
    }));
    var e, t = ["" + $(".search-header__input").attr("placeholder")],
        a = 0,
        i = 0,
        o = !0,
        s = 0;
    setInterval((function() {
        o ? i >= t[a].length && 15 == ++s && (o = !1, s = 0) : 0 == i && (o = !0, a++, i = 0, a >= 1 && (a = 0)), e = t[a].substr(0, i), 0 == s && (o ? i++ : i--), $(".search-w__animate").text(e)
    }), 70), $(".search-w__animate").click((function() {
        $(".search-header__input").focus()
    }))
}, novtheme.NovSearchOverlay = function() {
    $(".search__btn-overlay").on("click.break", (function(e) {
        $(".site-overlay__search .search-header__input").focus(), $(".overlay-search").addClass("open")
    })), $(".site-overlay__close").click((function() {
        $(".overlay-search").removeClass("open")
    }))
}, novtheme.goToTop = function() {
    $(window).scroll((function() {
        $(window).scrollTop() >= $(window).height() ? $("#_desktop_back_top").fadeIn(500) : $("#_desktop_back_top").fadeOut(100)
    })), $("#_desktop_back_top").click((function() {
        $("body,html").animate({
            scrollTop: 0
        }, "normal")
    }))
}, novtheme.goToTopMobile = function() {
    var e;
    $(window).width() < 768 && ($(window).scroll((function() {
        e && clearTimeout(e), e = setTimeout((function() {
            $("#back_top").fadeIn()
        }), 200)
    })), $("#back_top").click((function() {
        return $("body,html").animate({
            scrollTop: 0
        }, "normal"), !1
    })))
}, novtheme.PopupNewletter = function() {
    var e = new Date;
    e.setTime(e.getTime() + 36e5), "closed" != $.cookie("popupNewLetterStatus") && $("body").outerWidth() > 768 && $("#popup-subscribe").modal({
        show: !0
    }), "closed" != $.cookie("popupNewLetterStatus") && 1 == $("#popup-subscribe").data("sm") && $(window).width() < 768 && $("#popup-subscribe").modal({
        show: !0
    }), $("input.no-view").change((function() {
        1 == $("input.no-view").prop("checked") ? $.cookie("popupNewLetterStatus", "closed", {
            expires: e,
            path: "/"
        }) : $.cookie("popupNewLetterStatus", "", {
            expires: e,
            path: "/"
        })
    })), $("#popup-subscribe.promotion").click((function() {
        $.cookie("popupNewLetterStatus", "closed", {
            expires: e,
            path: "/"
        })
    }))
}, novtheme.MenuSidebar = function() {
    $(".categories__sidebar .hasSubCategory a").each((function(e) {
        $(this).hasClass("active") && $(this).parent().children(".collapse").collapse("show")
    }))
}, novtheme.Nov_iframe_video = function() {
    var e;
    $(".icon_play").click((function() {
        e = $(this).data("src")
    })), $("#ModalVideo").on("shown.bs.modal", (function(t) {
        $("#video").attr("src", e)
    })), $("#ModalVideo").on("hide.bs.modal", (function(e) {
        $("#video").attr("src", "")
    })), $(".btn-video__play").each((function() {
        var e = $(this).data("id");
        $(this).click((function() {
            $(this).fadeOut(), $('.bg-video__cover[data-id="' + e + '"]').fadeOut(), $('video[data-id="' + e + '"]').trigger("play")
        })), $(window).width() < 992 && $('video[data-id="' + e + '"]').trigger("play")
    }))
}, novtheme.MegaMenuSlider = function() {
    if ($("html").hasClass("lang-rtl")) var e = !0;
    else e = !1;
    var t = $(".nav--product .grid--view-items").data("autoplay");
    $(".nav--product .grid--view-items").slick({
        autoplay: t,
        autoplaySpeed: 2e3,
        infinite: !0,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: !1,
        arrows: !1,
        rtl: e
    })
}, novtheme.SliderSyncing = function() {
    if ($("html").hasClass("lang-rtl")) var e = !0;
    else e = !1;
    var t = $(".nov-slick-for").data("nav"),
        a = $(".nov-slick-for").data("dots");
    $(".nov-slick-for").slick({
        nextArrow: '<div class="arrow-next"><i class="zmdi zmdi-long-arrow-right"></i></div>',
        prevArrow: '<div class="arrow-prev"><i class="zmdi zmdi-long-arrow-left"></i></div>',
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: t,
        dots: a,
        asNavFor: ".nov-slick-nav",
        rtl: e
    }), $(".nov-slick-nav").slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: !1,
        dots: !1,
        asNavFor: ".nov-slick-for",
        rtl: e
    })
}, novtheme.LoadmoreByButton = function() {
    var e = $(".btn_loadmore"),
        t = $(e).parents(".grid--view-items"),
        a = $(t).data("xxl"),
        i = $(t).data("xl"),
        o = $(t).data("lg"),
        s = ($(t).data("md"), $(t).data("sm")),
        n = $(t).data("xs");
    $(t).find(".item").each((function() {
        if (index = $(this).index() + 1, $(document).width() > 1439) var e = a;
        if ($(document).width() < 1440 && $(document).width() > 1199) e = i;
        if ($(document).width() < 1200 && $(document).width() > 991) e = o;
        if ($(document).width() < 992 && $(document).width() > 767) e = o;
        if ($(document).width() < 768 && $(document).width() > 575) e = s;
        if ($(document).width() < 576) e = n;
        var t = index % e * .3;
        if ($(this).attr("data-wow-duration", t + "s"), index % e == 0) {
            var l = index % e + .3 * e;
            $(this).attr("data-wow-duration", l + "s")
        }
    })), $(e).each((function() {
        var e = $(this).attr("btn-handle"),
            t = $(this).attr("link");
        $("body").on("click", "." + e, (function() {
            $.ajax({
                url: t,
                type: "GET",
                dataType: "html",
                beforeSend: function() {
                    $("." + e).addClass("loading")
                }
            }).done((function(a) {
                $(".product__loadmore-" + e).append($(a).find(".product__loadmore-" + e).html());
                var i = $(".pagination__bar" + e).data("max"),
                    o = $(".product__loadmore-" + e),
                    s = $(o).data("xxl"),
                    n = $(o).data("xl"),
                    l = $(o).data("lg"),
                    c = ($(o).data("md"), $(o).data("sm")),
                    d = $(o).data("xs");
                $(o).find(".item").each((function() {
                    if (index = $(this).index() + 1, $(document).width() > 1439) var e = s;
                    if ($(document).width() < 1440 && $(document).width() > 1199) e = n;
                    if ($(document).width() < 1200 && $(document).width() > 991) e = l;
                    if ($(document).width() < 992 && $(document).width() > 767) e = l;
                    if ($(document).width() < 768 && $(document).width() > 575) e = c;
                    if ($(document).width() < 576) e = d;
                    var t = index % e * .3;
                    if ($(this).attr("data-wow-duration", t + "s"), index % e == 0) {
                        var a = index % e + .3 * e;
                        $(this).attr("data-wow-duration", a + "s")
                    }
                })), jdgm.customizeBadges(), t = $(a).find(".btn_loadmore").attr("link");
                var r = $(".product__loadmore-" + e).find(".item").length;
                $(".pagination__count" + e + " .count").text(r), $(".pagination__bar" + e + " .progress").css("width", r / i * 100 + "%"), r < i ? $("." + e).removeClass("loading") : $("." + e).remove()
            }))
        }))
    }))
}, novtheme.Mainmenu = function() {
    $(document).width() >= 1200 && $(".site-nav--btn").click((function() {
        $(this).toggleClass("act"), $("#AccessibleNav").toggleClass("act")
    })), $(document).width() < 1200 && $(document).width() > 767 && ($(".site-nav--btn").click((function() {
        $(this).hasClass("act") ? ($(this).removeClass("act"), $(".sidebar-overlay, #mobile_menu").removeClass("act")) : ($(this).addClass("act"), $(".sidebar-overlay, #mobile_menu").addClass("act")), $(".mobile-btn_search, #mobile_search").removeClass("act")
    })), $(".parent--lv1 .site-nav__link--main").click((function(e) {
        e.preventDefault(), $(this).hasClass("active") ? ($(this).removeClass("active"), $(this).parent().find(".nav-dropdown--lv1").slideUp(300), $(this).find(".site-nav--direc i").addClass("zmdi-chevron-down").removeClass("zmdi-chevron-up")) : ($(".nav-dropdown--lv1").slideUp(300), $(".site-nav__link--main").removeClass("active"), $(this).addClass("active"), $(this).parent().find(".nav-dropdown--lv1").slideDown(300), $(".site-nav__link--main .site-nav--direc i").addClass("zmdi-chevron-down").removeClass("zmdi-chevron-up"), $(this).find(".site-nav--direc i").addClass("zmdi-chevron-up").removeClass("zmdi-chevron-down")), $("#AccessibleNav .grid--view-items").slick("refresh")
    })), $(".parent--lv2 .site-nav__link--second").click((function(e) {
        e.preventDefault(), $(this).hasClass("active") ? ($(this).removeClass("active"), $(this).parent().find(".nav-dropdown--lv2").slideUp(300), $(this).find(".site-nav--direc i").addClass("zmdi-chevron-down").removeClass("zmdi-chevron-up")) : ($(".nav-dropdown--lv2").slideUp(300), $(".site-nav__link--second").removeClass("active"), $(this).addClass("active"), $(this).parent().find(".nav-dropdown--lv2").slideDown(300), $(".site-nav__link--second .site-nav--direc i").addClass("zmdi-chevron-down").removeClass("zmdi-chevron-up"), $(this).find(".site-nav--direc i").addClass("zmdi-chevron-up").removeClass("zmdi-chevron-down"))
    })))
}, novtheme.CollectionPage = function() {
    localStorage.getItem("view_collection") && ($(".gridlist-toggle a").removeClass("active"), $('.gridlist-toggle [data-type="' + localStorage.getItem("view_collection") + '"]').length > 0 ? ($('.gridlist-toggle [data-type="' + localStorage.getItem("view_collection") + '"]').addClass("active"), $(".collection__product-content").attr("data-grid", localStorage.getItem("view_collection"))) : ($(".gridlist-toggle a:first-child").addClass("active"), $(".collection__product-content").attr("data-grid", $(".gridlist-toggle a:first-child").data("type")))), $(".gridlist-toggle a").click((function(e) {
        e.preventDefault();
        var t = $(this).data("type");
        $(this).hasClass("active") || ($(".collection__product-content").attr("data-grid", t), $(".gridlist-toggle a").removeClass("active"), $(this).addClass("active")), localStorage.setItem("view_collection", $(".collection__product-content").attr("data-grid"))
    })), $(document).width() < 992 && ($(".collection__product-content").attr("data-grid", "grid-3"), $(".gridlist-toggle a").removeClass("active"), $(".gridlist-toggle #grid-3").addClass("active"), $(".collection-topsidebar .facets__label").addClass("act")), $(document).width() < 768 && ($(".collection__product-content").attr("data-grid", "grid-2"), $(".gridlist-toggle a").removeClass("active"), $(".gridlist-toggle #grid-2").addClass("active"));
    var e = $('.FacetsWrapperDesktop [name="sort_by"] [selected="selected"]').text(),
        t = $('.FacetsWrapperDesktop [name="sort_by"] [selected="selected"]').attr("value");
    $("[data-sortby-filter] .sort-by__label").text(e), $('[data-sortby-filter] [value="' + t + '"]').addClass("act"), $("[data-sortby-item]").click((function() {
        var e = $(this).attr("value"),
            t = $(this).text();
        $("[data-sortby-item]").removeClass("act"), $(this).addClass("act"), $("[data-sortby-filter] .sort-by__label").text(t), $('[name="sort_by"]').val(e);
        const a = document.querySelector("facet-filters-form");
        a.onSubmitHandlerSortBy(event, a.querySelector("form"))
    })), $(".collection__category-seemore").click((function() {
        $(".collection__category-item.hide").slideToggle(300)
    }))
}, novtheme.CollectionPageLoadmore = function() {
    var e = $(".collection__grid-loadmore"),
        t = e.data("next-url");
    t && $(".collection__btn-loadmore").click((function() {
        $.ajax({
            url: t,
            type: "GET",
            dataType: "html",
            beforeSend: function() {
                $(".collection__btn-loadmore").addClass("loading")
            }
        }).done((function(a) {
            var i = $(a).find(".collection__grid-loadmore"),
                o = i.data("next-url"),
                s = $(".pagination__bar").data("max");
            void 0 !== (t = o) ? $(".collection__btn-loadmore").removeClass("loading") : $(".collection__btn-loadmore").remove(), e.append(i.html());
            var n = e.find(".product--item").length;
            $(".pagination__count .count").text(n), $(".pagination__bar .progress").css("width", n / s * 100 + "%"), $(".jdgm-widget").length && jdgm.customizeBadges(), Currency.convertAll(shopCurrency, $("#currencies span.selected").attr("data-currency"))
        }))
    }))
}, novtheme.NovAccordion = function() {
    $(".nov-accordion__title").each((function() {
        $(window).width() < 768 && ($(this).removeClass("act"), $(this).parent().find(".nov-accordion__content").hide()), $(this).hasClass("act") && $(this).parent().find(".nov-accordion__content").show(), $(this).click((function() {
            $(this).hasClass("act") ? ($(this).removeClass("act"), $(this).parent().find(".nov-accordion__content").slideUp()) : ($(this).parents(".nov-accordion").find(".nov-accordion__title").removeClass("act"), $(this).parents(".nov-accordion").find(".nov-accordion__content").slideUp(), $(this).addClass("act"), $(this).parent().find(".nov-accordion__content").slideDown())
        }))
    }))
}, novtheme.RunParallax = function() {
    var e = $(window).height();
    $(".block__parallax").length && $(".block__parallax").each((function() {
        var t = !1,
            a = $(this).offset().top - e;
        $(window).on("scroll", (function() {
            $(document).scrollTop() > a && !1 === t && (t = !0, novtheme.Parallax())
        }))
    }))
}, novtheme.Parallax = function() {
    $(window).scroll((function() {
        $(".block__parallax").each((function() {
            var e = $(window).height(),
                t = $(window).scrollTop(),
                a = $(this).children().data("section-id"),
                i = .22 * (t - ($(this).offset().top - e));
            $("#shopify-section-" + a + " .itemY_parallax").css("transform", "translateY(-" + i + "px)"), $("#shopify-section-" + a + " .reverseY_parallax").css("transform", "translateY(" + i + "px)"), $("#shopify-section-" + a + " .itemX_parallax").css("transform", "translateX(-" + i + "px)"), $("#shopify-section-" + a + " .reverseX_parallax").css("transform", "translateX(" + i + "px)")
        }))
    }))
}, novtheme.LookBook = function() {
    if ($("html").hasClass("lang-rtl")) var e = !0;
    else e = !1;
    $(".nov-content-lookbook").each((function() {
        var t = $(this),
            a = t.find(".Lookbook__carousel"),
            i = t.find(".lb_btn"),
            o = t.find(".number-lookbook");
        i.click((function() {
            a.not(".owl-loaded") && (a.owlCarousel({
                navText: ['<i class="zmdi zmdi-chevron-left"></i>', '<i class="zmdi zmdi-chevron-right"></i>'],
                nav: !0,
                dots: !1,
                items: 1,
                margin: 10,
                stagePadding: 0,
                animateIn: "fadeInDown",
                animateOut: "fadeOutRight",
                lazyLoad: !0,
                mouseDrag: !0,
                touchDrag: !0,
                autoHeight: !0,
                rtl: e,
                responsive: {
                    0: {
                        nav: !1
                    },
                    1200: {
                        nav: !0
                    }
                }
            }), a.on("changed.owl.carousel", (function(e) {
                var t = e.item.index;
                o.removeClass("active"), o.parent().find("[data-position=" + t + "]").addClass("active")
            })))
        })), o.click((function() {
            var e = $(this).data("position");
            o.removeClass("active"), $(this).addClass("active"), a.trigger("to.owl.carousel", e)
        }))
    })), $(".Look__content").each((function() {
        var e = $(this);
        xl = e.data("xl"), e.find(".btn_loadmore").click((function() {
            var t = e.find(".item.show").length + xl;
            e.find(".item.hide").each((function() {
                $(this).data("position") <= t && ($(this).slideDown("700", "linear").removeClass("hide").addClass("show"), 0 == e.find(".item.hide").length && (e.find(".btn_loadmore").parent().hide(), e.parents(".distance").removeClass("h_sm")))
            }))
        }))
    })), $(".item-lookbook").length > 0 && $(".item-lookbook").each((function() {
        var e = $(this),
            t = $(this).children(".content-lookbook"),
            a = e.position().top,
            i = e.position().left,
            o = e.outerWidth(),
            s = e.offsetParent().height(),
            n = e.offsetParent().width(),
            l = t.width();
        n / 2 < i ? (t.css("right", (o - 40) / 2 + 40), n - i + l > n && t.css("margin-right", -1 * (n - i + l - n))) : (t.css("left", (o - 40) / 2 + 40), i + o + l > n && t.css("margin-left", -1 * (i + o + l - n))), s / 2 < a ? t.css("bottom", "60px") : t.css("top", "60px")
    }))
}, novtheme.Language = function() {
    $(".nov-language").each((function() {
        var e = $(this),
            t = $(this).find('input[name="locale_code"], input[name="country_code"]');
        $(this).find(".lang__item").click((function() {
            var a = $(this).data("value");
            t.val(a), e.submit()
        }))
    }))
}, novtheme.CartExtent = function() {
    var e = theme.strings.close_mini_canvas;
    if ($(document).on("click", ".extend--label__item", (function() {
            var t = $(this).data("label");
            if ($(this).hasClass("act")) $(this).removeClass("act"), $(".cart_extend").removeClass("act"), $(".cart_extend--label").removeClass("act"), $(this).attr("data-original-title", t);
            else {
                var a = $(this).siblings();
                a.each((function() {
                    var e = $(this).data("title");
                    a.removeClass("act"), a.attr("data-original-title", e)
                })), $(".cart_extend").removeClass("act"), $(".cart_extend--label").removeClass("act"), $(this).addClass("act"), $(this).attr("data-original-title", e), $('.cart_extend[data-content="' + t + '"]').addClass("act"), $(".cart_extend--label").addClass("act")
            }
            $(window).width() < 768 && $(".block_cart_canvas #desktop_cart").addClass("open-extend")
        })), $(".extend--label__item").hover((function() {
            var t = $(this).attr("title");
            $(this).hasClass("act") ? $(this).attr("data-original-title", e) : $(this).attr("data-original-title", t)
        }), (function() {
            $(this).hasClass("act") && "undefined" != typeof title ? $(this).attr("data-original-title", title) : $(this).attr("data-original-title", e)
        })), $(document).on("click", ".cart_extend--btn", (function() {
            $(".cart_extend").removeClass("act"), $(".cart_extend--label").removeClass("act"), $(".extend--label__item").removeClass("act"), $(window).width() < 768 && $(".block_cart_canvas #desktop_cart").removeClass("open-extend")
        })), $(".btn_save--discount").click((function() {
            var e = $(this).parent().find("input").val();
            $(".js-form-discount").val(e)
        })), $discountInput = $("input.js-form-discount"), $coupon = function(e, t) {
            t || (t = window.location.href), e = e.replace(/[\[\]]/g, "\\$&");
            var a = new RegExp("[?&]" + e + "(=([^&#]*)|&|#|$)").exec(t);
            return a ? a[2] ? decodeURIComponent(a[2].replace(/\+/g, " ")) : "" : null
        }("coupon"), $coupon && $.cookie("discountCode", $coupon, 30), $discountCode = $.cookie("discountCode"), $discountCode && $discountInput.length > 0 && $discountInput.val($discountCode), $(window).width() < 768) {
        var t = $("#desktop_cart.item_count .block_cart_top").height(),
            a = !0,
            i = 0;
        $("#desktop_cart").scroll((function() {
            var e = $("#desktop_cart").scrollTop();
            e > t ? $("#desktop_cart.item_count .block_cart_top").addClass("scroll-down") : $("#desktop_cart.item_count .block_cart_top").removeClass("scroll-down"), e < i && e > t ? 1 == a && ($("#desktop_cart.item_count .block_cart_top").removeClass("scroll-down").addClass("sticky-sm"), a = !1) : 0 == a && ($("#desktop_cart.item_count .block_cart_top").addClass("scroll-down").removeClass("sticky-sm"), a = !0), i = e
        }))
    }
}, novtheme.AddActive = function() {
    $("[nov-btn-act]").click((function() {
        var e = $(this).data("toggle");
        $(this).hasClass("act") ? ($(this).removeClass("act"), $('[data-act="' + e + '"]').removeClass("act"), $("body").removeClass(e + "-open"), $(this).is("[overlay]") && $(".sidebar-overlay").removeClass("act").removeAttr("data-close")) : ($("[nov-btn-act]").removeClass("act"), $(this).addClass("act"), $("[nov-item-act]").removeClass("act"), $('[data-act="' + e + '"]').addClass("act"), $("body").addClass(e + "-open"), $(this).is("[overlay]") && $(".sidebar-overlay").addClass("act").attr("data-close", e))
    })), $("[nov-btn-close]").click((function() {
        var e = $(this).data("close");
        $('[data-act="' + e + '"], .sidebar-overlay, [nov-btn-act]').removeClass("act"), $(".sidebar-overlay").removeAttr("data-close"), $("body").removeClass(e + "-open")
    })), $('[data-toggle="modal"]').click((function() {
        $("[nov-btn-act], [nov-item-act]").removeClass("act"), $(".sidebar-overlay").removeClass("act")
    })), $("[btn-toggle]").click((function() {
        var e = $(this).data("toggle");
        $(this).toggleClass("act"), $('[nov-toggle="' + e + '"]').slideToggle(400)
    }))
}, novtheme.ProductStick = function() {
    var e = $(window).height();
    $(window).scroll((function() {
        $(window).scrollTop() > e ? $(".product-single__stick-add").addClass("act") : $(".product-single__stick-add").removeClass("act")
    })), $(window).on("load", (function() {
        if ($(".product-single__stick-add").length > 0 && $(window).width() >= 768) {
            var e = $(".product-single__stick-add").height();
            $("body").css("padding-bottom", e)
        }
    }))
}, novtheme.PageSizeGuild = function() {
    $(".size-guide__btn-switch").on("click", (function() {
        var e = $(this).closest(".size-guides__container");
        $(this).hasClass("act") ? (e.find(".size-guides__switch").css("transform", "translate(0)"), e.find(".size-chart__1").show(), e.find(".size-chart__2").hide()) : ($("html").hasClass("lang-rtl") ? e.find(".size-guides__switch").css("transform", "translate(-100%)") : e.find(".size-guides__switch").css("transform", "translate(100%)"), e.find(".size-chart__1").hide(), e.find(".size-chart__2").show())
    })), $(".size-guides__links-division").on("click", "a", (function(e) {
        e.preventDefault;
        var t = $("html, body"),
            a = $(this).attr("data-scroll");
        $("#nov-sizeguide-product").length > 0 ? $("#nov-sizeguide-product").animate({
            scrollTop: $('.size-guides__container[data-scrolled="' + a + '"]').position().top
        }, "5000", "swing") : t.animate({
            scrollTop: $('.size-guides__container[data-scrolled="' + a + '"]').offset().top
        }, "5000", "swing")
    }))
}, novtheme.MobileSlider = function() {
    $(window).width() < 768 && $(".nov-slide-mobile").each((function() {
        if ($("html").hasClass("lang-rtl")) var e = !0;
        else e = !1;
        $(this).slick({
            autoplaySpeed: 2e3,
            slidesToShow: 2,
            slidesToScroll: 2,
            arrows: !1,
            dots: !0,
            rtl: e,
            responsive: [{
                breakpoint: 576,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }]
        })
    }))
}, novtheme.ProductSingleSlider = function() {
    $(".nov-product__single-slide").each((function() {
        if ($("html").hasClass("lang-rtl")) var e = !0;
        else e = !1;
        var t = $(this),
            a = t.data("autoplay"),
            i = t.data("speed");
        t.slick({
            autoplay: a,
            autoplaySpeed: i,
            speed: 500,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: !1,
            dots: !0,
            rtl: e,
            pauseOnHover: !1,
            pauseOnFocus: !1,
            adaptiveHeight: !0
        })
    }))
}, novtheme.NovSnow = function() {
    $(".nov-snow").each((function() {
        for (var e = $(this), t = e.data("limit"), a = 0; a < t; a++) e.append("<div></div>")
    }));
    const e = document.querySelector(".nov-snow");
    if (e) {
        new IntersectionObserver((function(t, a) {
            t[0].isIntersecting ? e.classList.add("act") : e.classList.remove("act")
        })).observe(e)
    }
}, novtheme.SlideShowParallax = function() {
    $(window).width() > 1023 && $(".section-slideshow .img_animate").parallax()
}, novtheme.Vertical = function() {
    var e = $(".site-nav-vertical"),
        t = e.find(".vertical-item").length,
        a = e.data("count"),
        i = a - 1,
        o = e.data("count_xxl"),
        s = o - 1,
        n = e.data("count_xl"),
        l = n - 1,
        c = e.data("count_lg"),
        d = c - 1,
        r = e.data("textshowmore"),
        h = e.data("textless"),
        m = e.find(".ver-show__more"),
        v = $(document).width();
    $(".btn-vertical").click((function() {
        v > 991 && ($(this).hasClass("disable_click") ? v < 1200 && $(".site-nav-vertical").slideToggle(400) : $(".site-nav-vertical").slideToggle(400)), $(document).width() < 992 && ($(".site-nav-vertical").addClass("active"), $(".sidebar-overlay").addClass("act"))
    })), $(document).width() > 991 && $("body").not(".template-index").find(".site-nav-vertical").hide(), $(document).width() < 1200 && $(document).width() > 991 && $(".site-nav-vertical").hide(), t > a && v > 1599 ? (m.removeClass("hide"), e.find(".vertical-item:gt(" + i + ")").addClass("hide")) : t > o && v < 1600 && v > 1439 ? (m.removeClass("hide"), e.find(".vertical-item:gt(" + s + ")").addClass("hide")) : t > n && v < 1440 && v > 1199 ? (m.removeClass("hide"), e.find(".vertical-item:gt(" + l + ")").addClass("hide")) : t > c && v < 1200 && v > 991 ? (m.removeClass("hide"), e.find(".vertical-item:gt(" + d + ")").addClass("hide")) : (m.addClass("hide"), e.find(".vertical-item").removeClass("hide")), m.click((function() {
        $(this).hasClass("active") ? ($(this).removeClass("active"), $(this).find(".show-more__text").text(r)) : ($(this).addClass("active"), $(this).find(".show-more__text").text(h)), e.find("li.hide").slideToggle(300)
    }))
}, novtheme.BtnSlider = function() {
    $(".nov-btn-click-slider").each((function() {
        var e = $(this),
            t = (e.width(), e.find(".el-slider")),
            a = e.find(".btn-slider__el"),
            i = e.find(".active").outerWidth(),
            o = e.find(".active").outerHeight(),
            s = e.find(".active").parent().position().left;
        t.css({
            width: i,
            height: o,
            left: s
        }), a.click((function() {
            var e = $(this).parent().position().left,
                a = $(this).outerWidth();
            t.css({
                left: e,
                width: a
            })
        }))
    }))
}, novtheme.NavDropdownMobile = function() {
    $(".nav-mobile").each((function() {
        el = $(this);
        var e = el.find(".active").text(),
            t = el.find(".nav-mobile__title");
        t.text(e), el.find(".nav-link").click((function() {
            t.text($(this).text())
        }))
    }))
}, novtheme.NumberAnimate = function() {
    var e = $(window).height();
    $(".number-animate").each((function() {
        var t = $(this),
            a = !1,
            i = t.offset().top - e;
        $(window).on("scroll", (function() {
            if ($(this).scrollTop() > i && !a) {
                a = !0, t.prop("number", 0).animate({
                    number: t.text()
                }, {
                    duration: 2e3,
                    easing: "swing",
                    step: function(e) {
                        $(this).text(Math.ceil(e))
                    }
                })
            }
        }))
    }))
}, novtheme.FakeOrder = function() {
    if ($("#nov-popup-fake-order").length > 0) {
        var e = $("#nov-popup-fake-order"),
            t = $("#fake-order-data"),
            a = e.find(".close-popup"),
            i = $("#nov-popup-fake-order").data("xs"),
            o = new Date,
            s = e.data("time");
        o.setTime(o.getTime() + s);
        var n = setInterval((function() {
            ! function(e, t) {
                if (e.hasClass("act")) e.removeClass("act");
                else {
                    var a = e.find(".product-image"),
                        i = e.find(".product-title"),
                        o = e.find(".time"),
                        s = e.find(".name"),
                        n = e.find(".local"),
                        l = $(t).find(".product-item"),
                        c = Math.floor(Math.random() * l.length),
                        d = l.eq(c),
                        r = d.data("img"),
                        h = d.data("title"),
                        m = d.data("src"),
                        v = $(t).find(".time-item"),
                        u = (c = Math.floor(Math.random() * v.length), v.eq(c).data("time")),
                        p = $(t).find(".location-item"),
                        f = (c = Math.floor(Math.random() * p.length), p.eq(c).data("local")),
                        g = $(t).find(".name-item"),
                        _ = (c = Math.floor(Math.random() * g.length), g.eq(c).data("name"));
                    a.attr("href", m), a.find("img").attr("src", r), i.html(h).attr("href", m), o.html(u), s.html(_), n.html(f), e.addClass("act")
                }
            }(e, t)
        }), s);
        "closed" != $.cookie("FakeOrder") || clearInterval(n), a.click((function() {
            $.cookie("FakeOrder", "closed", {
                expires: 1,
                path: "/"
            }), e.removeClass("act"), clearInterval(n)
        })), !1 === i && e.remove()
    }
}, novtheme.CookieGDPR = function() {
    var e = new Date;
    e.setTime(e.getTime() + 864e5), "closed" !== $.cookie("CookieGDPR") && $("#popup-CookieGDPR").addClass("act"), $(".btn-cookie-GDPR").click((function() {
        $.cookie("CookieGDPR", "closed", {
            expires: e,
            path: "/"
        }), $("#popup-CookieGDPR").removeClass("act")
    }))
}, $(document).ready((function() {
    var e = $(this),
        t = !1,
        time_show = theme.time_show * 1000;
    $(novtheme.init), responsive_mobile && novtheme.toggleMobileStyles(), $("#popup-subscribe").length && $(window).on("load", (function() {
        setTimeout((function() {
            novtheme.PopupNewletter()
        }), time_show)
    })), $("#popupAlert").length && ($(window).on("load", (function() {
        $("#popupAlert").modal()
    })), $("#popupAlert").click((function() {
        const e = window.location.href,
            t = e.indexOf("?customer");
        if (-1 !== t) {
            const a = e.slice(0, t);
            history.pushState({}, "", a)
        }
    })));
    var a = window.innerHeight;
    if ($(window).on("resize", (function() {
            window.innerHeight - a > 200 && novtheme.CollectionPage(), e.width() <= 980 && 0 == t ? t = !0 : e.width() > 980 && (t = !1)
        })), $(".sidebar-overlay").on("click", (function() {
            var e = $(this).data("close");
            $(this).removeClass("act"), $(".cart_extend, .extend--label__item, .cart_extend--label, #mobile_menu, #show-megamenu, .site-nav--btn, [nov-item-act], [nov-btn-act]").removeClass("act"), $("#desktop_cart, #AccessibleNav, .block_account_canvas, #_desktop_vertical__menu, #_mobile_vertical__menu, #mobile-pageaccount, .site-nav-vertical").removeClass("active"), $("body").css("overflow", "auto").removeClass("open-canvans-cart, " + e + "-open"), $(this).removeAttr("data-close")
        })), $(".group-quantity .btnProductWishlist").click((function() {
            $(this).hasClass("whislist-added") ? $("#popup-Wishlist").removeClass("novload") : $("#popup-Wishlist").addClass("novload")
        })), $(window).width() >= 992) {
        var i = $(".image-zoom");
        $(".image-zoom").each((function() {
            (i = $(this)).trigger("zoom.destroy"), i.wrap('<span class="w-100" style="display:block"></span>').css("display", "block").parent().zoom({
                url: i.attr("data-zoom")
            })
        }))
    }
    $(".no-view").click((function() {
        $(".contact-form").hasClass("add") ? $(".contact-form").removeClass("add") : $(".contact-form").addClass("add")
    })), $(".f_btn_sl").click((function(e) {
        $(this).hasClass("active") ? ($(this).removeClass("active"), $(this).parents(".block_footer").find(".block-content.h_t").slideUp(300)) : ($(".f_btn_sl").removeClass("active"), $(".block_footer .block-content.h_t").slideUp(300), $(this).addClass("active"), $(this).parents(".block_footer").find(".block-content.h_t").slideDown(300))
    })), $(".faqs-main .panel-header").click((function(e) {
        $(this).hasClass("collapsed") ? ($(".faqs-main").removeClass("active"), $(this).parents(".faqs-main").addClass("active")) : $(this).parents(".faqs-main").removeClass("active")
    })), $(".promotion-close").click((function() {
        $("[promationBar]").slideUp(300).removeClass("act")
    })), (new WOW).init()
}));